import ConfigType, {requireConfig} from '../../config/config';

export const useConfig: () => ConfigType = () => {
  return requireConfig();
};

export default useConfig;
